/*
 * Copyright (c) 2014-2024 Comparatio USA  LLC. <https://www.comparatio.com>
 */

import {Component, Inject, OnInit} from '@angular/core';
import {ShipmentHeadersService} from '../../../services/shipment-headers.service';
import {OrderHeadersService} from '../../../services/order-headers.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {permissions} from '../../../permissions';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {ShipmentLinesService} from '../../../services/shipment-lines.service';
import {Page} from '../../../model/page';

@Component({
  selector: 'app-shipment-lines-model',
  templateUrl: './shipment-lines-model.component.html',
  styleUrls: ['./shipment-lines-model.component.scss'],
  providers: [
    OrderHeadersService,
    ShipmentHeadersService,
    ShipmentLinesService
  ]
})
export class ShipmentLinesModalComponent implements OnInit {

  SH1_UPLOAD_TIMESTAMP: number = null;
  po: any = [];
  rows = [];
  cols = [];
  totalRecords = 0;
  selected = [];

  public loading = false;
  public  permissions = permissions;


  constructor(
    public dialogRef: MatDialogRef<ShipmentLinesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private shipmentHeadersService: ShipmentHeadersService,
    private orderHeadersService: OrderHeadersService,
    private shipmentLinesService: ShipmentLinesService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) {

    this.cols = [
      { field: 'SH1_INTERNAL_ID',     header: 'Shipment Number',        visible: true,  width: 100 },
      { field: 'SH1_TRACKING_NUMBER', header: 'Tracking Number',        visible: true,  width: 100 },
      { field: 'SH2_QUANTITY',        header: 'Shipped Qty',            visible: true,  width: 100 },
      { field: 'SH2_CREATED_ON',      header: 'Created On',             visible: true,  width: 100 },
      { field: 'SH2_CREATED_BY',      header: 'Created By',             visible: true,  width: 100 },
      { field: 'SH2_SHIPMENT_DATE',   header: 'Shipment Date',          visible: true,  width: 100 },
      { field: 'SH2_ARRIVAL_DATE',    header: 'Estimated Arrival Date', visible: true,  width: 100 }
    ];
  }

  ngOnInit() {

    this.loading = true;
    const page = new Page();
    page.filterParams = {
      PO1_ID: this.data.PO1_ID,
      PO2_ID: this.data.PO2_ID
    }
    this.shipmentLinesService.getItems(page).subscribe( (res:any) => {
      this.rows = res.data;
      this.loading = false;
    },error => {
        this.loading = false;
        window.dispatchEvent(new Event('resize'));
        this.toastr.error('TimeOut occured', 'Service Error', {
            timeOut: 3000,
        });
    });
  }

  openShipment(SH1_UPLOAD_TIMESTAMP: string) {
    this.dialogRef.close();
    this.router.navigate(['shipment-headers/view/' + SH1_UPLOAD_TIMESTAMP]);
  }

  closeDialog(){
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/shipment-headers/shipment-lines-modal/shipment-lines-modal.component.ts